import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, KeyValueDiffer, KeyValueDiffers, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import { NumberInputComponentV3 } from 'dist/yt-ng-framework/lib/base-components/input/number-input/number-input-v3.component';
import { ColumnData } from 'yt-ng-framework/lib/base-models/column-data';
import { List } from 'immutable';
import { BaseDataService, CollectionService, QueryParameter, TableRowColor, UserService } from 'yt-ng-framework';
import { SpisakDokumenataStavkeV2 } from '../spisak-dokumenata-v2';

@Component({
  selector: 'yt-fw-default-table-with-expand',
  templateUrl: './default-table-with-expand.component.html'
})
export class DefaultTableWithExpandComponent implements OnInit {

  constructor(
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    public userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private collectionService: CollectionService,
    private keyValueDiffers: KeyValueDiffers,
    private baseDataService: BaseDataService
  ) { }

  Items: List<any>;
  Items2: List<any>;
  originalItems: List<any>;
  private selectedItemIndex: number = 0;
  inputSelectedItem;
  keyValueDiffer: KeyValueDiffer<any, any>;
  sortReverse: boolean;
  sortKey: string;
  sortLabel: string;
  checkAll: boolean = false;
  defaultTableName: number = parseInt((Math.random() * 100).toFixed(0));
  detailTableVisible: boolean = true;
  userRights;

  @Input() Config: any;
  @Input() Condensed: boolean;
  @Input() ShowLoader: boolean;
  @Input() set KeyCode(value: number){
    // console.log('Default table keyCode: ' + value);
    if(value == 13 && this.Items)
      this.SelectItem(this.Items.get(this.selectedItemIndex));
    else if(value == 38 || value == 40)
      this.setActiveItem(value);
  }
  // @Input() set SetFilter(value: string){
  //   this.Filter(value);
  // }
  @Input() set SetSelectedItem(value){
    //this.SelectItem(value);
    this.inputSelectedItem = value;
    if(this.Items != null)
      this.Items.forEach(item => {
        item.Selected = false;
        if(value && (value['ID'] == item['ID']))
          item['Selected'] = true;
      })
      this.changeDetectorRef.markForCheck();
  }
  // @Input() FilterByAllColumns: boolean = true;
  @Input() RowColors: TableRowColor[];
  // @Input() set ScrollToView(value: boolean) {
  //   let _this = this;
  //   setTimeout(() => {
  //     let tableRect = _this.tableBody.nativeElement.getBoundingClientRect();
  //     let activeRow;
  //     let i;
  //     for(i = 0; i < this.tableBody.nativeElement.rows.length; i++)
  //       //if(this.tableBody.nativeElement.rows[i].className == 'table-active')
  //       if(this.tableBody.nativeElement.rows[i].className.indexOf('table-active') > -1)
  //         activeRow = this.tableBody.nativeElement.rows[i];
  //     if(activeRow){
  //       let rowRect = activeRow.getBoundingClientRect();
  //       let isViewable = (rowRect.top >= tableRect.top) && (rowRect.top <= tableRect.top + this.tableBody.nativeElement.clientHeight);
  //       if(!isViewable)
  //         this.tableBody.nativeElement.scrollTop = (rowRect.top + this.tableBody.nativeElement.scrollTop) - tableRect.top;
  //     }
  //     else{
  //       this.tableBody.nativeElement.scrollTop = 0;
  //     }
  //   }, 100)
  // }

  @Input() TableColumns: ColumnData[];
  @Input() Table2Columns: ColumnData[];
  @Input('Items') set SetItems(items: List<any>) { 
      this.Items = items;
      this.originalItems = items;
       if(this.Items && this.Items.size > 0){
        this.selectedItemIndex = 0;
        if(this.Items.find(item => item.Selected == true) != null){
          this.inputSelectedItem = this.Items.find(item => item.Selected == true);
          this.Items.filter(item => item.Selected == true && item.ID != this.inputSelectedItem.ID).forEach(item => item.Selected = false);
          this.changeDetectorRef.markForCheck();
        }
        if(this.inputSelectedItem)
          this.selectedItemIndex = this.Items.indexOf(this.inputSelectedItem);
        this.keyValueDiffer = this.keyValueDiffers.find(this.Items).create();
        // if(this.sortKey || (this.Config && this.Config.DefaultSortKey)){
        //   if(this.sortLabel == null){
        //     let tableColumn = this.TableColumns.find(column => column.Name == (this.sortKey != null ? this.sortKey : this.Config.DefaultSortKey));
        //     this.sortLabel = tableColumn != null ? tableColumn.Label : (this.sortKey == 'ID' || this.Config.DefaultSortKey == 'ID' ? 'unosu' : '');
        //   }
        //   this.SortItems(this.sortKey != null ? this.sortKey : this.Config.DefaultSortKey, false, this.sortLabel);
        //   let item = null;
        //   if(this.inputSelectedItem == null)
        //     item = this.Items.get(this.selectedItemIndex);
        //   else
        //     item = this.Items.find(item => item.ID == this.inputSelectedItem.ID);
        //   if(item == null)
        //     item = this.Items.get(0);
        //   item.Selected = true;
        //   this.ItemActivated.emit(item);
        //   this.changeDetectorRef.markForCheck();
        // }       
      }
  }
  
  @Input() ModelName2: string;
  @Input() GetName2: string;
  @Input() GetParameters2: QueryParameter[];
  @Input() ModelClass2: new() => any = SpisakDokumenataStavkeV2;

  @Output() ItemActivated = new EventEmitter();
  @Output() ItemCheckClicked = new EventEmitter();
  @Output() ItemSelected = new EventEmitter();
  @Output() ColumnsRatioChanged = new EventEmitter();
  @Output() RefreshDataClicked = new EventEmitter();

  @ViewChild('table', { static: true }) table: ElementRef;
  @ViewChild('tbody', { static: true }) tableBody: ElementRef;
  @ViewChild('thead', { static: true }) tableHead: ElementRef;

  @ViewChild('table2', { static: true }) table2: ElementRef;
  @ViewChild('tbody2', { static: true }) tableBody2: ElementRef;
  @ViewChild('thead2', { static: true }) tableHead2: ElementRef;

  // @ViewChild('numberInputV3') numberInputV3: NumberInputComponentV3;

  ngOnInit() {
    // this.sortReverse = this.Config.DefaultSortReverse; 
    // let inputControl = this.numberInputV3.inputControl.nativeElement; 
    // inputControl.setAttribute('style', 'font-size: 0.9em')
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.calculateHeight();
    }, 1100);
  }

  calculateHeight(){
    // this.tableBody.nativeElement.style.height = this.table.nativeElement.style.height.substring(0, this.table.nativeElement.style.height.indexOf('px')) -
    //   (this.tableHead ? (this.tableHead.nativeElement.clientHeight > 0 ? this.tableHead.nativeElement.clientHeight : 37) : 0) -
    //   (this.tableFooter ? (this.tableFooter.nativeElement.clientHeight > 0 ? this.tableFooter.nativeElement.clientHeight : 22) : 0) + 'px';

    if (this.tableBody && this.tableBody2){
      this.tableBody.nativeElement.style.height = this.table.nativeElement.style.height.substring(0, this.table.nativeElement.style.height.indexOf('px')) -
      (this.tableHead ? (this.tableHead.nativeElement.clientHeight > 0 ? this.tableHead.nativeElement.clientHeight : 37) : 0) + 'px'
  
      this.tableBody2.nativeElement.style.height = this.table2.nativeElement.style.height.substring(0, this.table2.nativeElement.style.height.indexOf('px')) -
      (this.tableHead2 ? (this.tableHead2.nativeElement.clientHeight > 0 ? this.tableHead2.nativeElement.clientHeight : 37) : 0) + 'px'
    }
  }

  // SortItems(sortKey: string, revert: boolean, sortLabel: string){
   
  //   this.sortKey = sortKey;
  //   this.sortLabel = sortLabel;
  //   if(revert)
  //     this.sortReverse = !this.sortReverse;
  //   this.Items = this.collectionService.SortItems(this.Items, sortKey, this.sortReverse);
  //   //this.sortReverse = !this.sortReverse;
  // }

  // Filter(filter){
  //   this.Items = this.collectionService.FilterItems(this.originalItems, filter, this.FilterByAllColumns ? '' : this.sortKey, this.TableColumns);
  //   if(this.Items && this.Items.size > 0) this.ItemActivated.emit(this.Items[0]);
  //   else this.ItemActivated.emit(null);

  //   if(this.Items)
  //     this.Items.forEach(item => {
  //       item.Selected = false;
  //     })
  //   if(this.Items && this.Items.size > 0)
  //     this.Items.get(0).Selected = true;

  //   if((filter == '') && this.Items){
  //     this.Items.forEach(item => {
  //       item.Selected = false
  //     });
  //     //this.Items.get(0).Selected = true;
  //     if(this.inputSelectedItem)
  //       this.Items.find(item => item.ID == this.inputSelectedItem.ID).Selected = true;
  //     this.ScrollToView = true;
  //   }
  // }

  GetPropertyValue(item, property, type, format){
    if(property.indexOf('.') == -1)
      return this.getValue(item[property], type, format);
    else
      return this.GetPropertyValue(item[property.split('.')[0]], property.split('.')[1], type, format);
  }

  private getValue(propertyValue, type: string, format: string){
    if(propertyValue == null)
      return null;
    if(propertyValue == '')
      return '';
    switch(type){
      case 'text': return propertyValue;
      case 'datetime': return this.datePipe.transform(propertyValue, format, '', this.userService.GetLocaleString());
      case 'number': return this.decimalPipe.transform(propertyValue, format, this.userService.GetLocaleString());
      case 'date': return this.datePipe.transform(propertyValue, format);
      case 'ngbDate': return this.datePipe.transform(new Date(propertyValue.year.toString() + '/' + propertyValue.month.toString() + '/' + propertyValue.day.toString()), format);
      case 'boolean': return (propertyValue == true ? "<span class='fa fa-fw fa-check'></span>" : '')
      default: return propertyValue;
    }
  }

  CheckItem(item){
    this.ItemCheckClicked.emit({ ID: item.ID, isChecked: item.Checked});
    // if (item.Checked == false){
    //   this.Items2 = null;
    //   return;
    // }
    if (item.Checked && item.Details && item.Details.length == 0)
    this.baseDataService.Post(this.ModelName2, this.GetName2, {'VezaDokID': item.VezaDokID, 'ID': item.ID}, this.ModelClass2)
      .subscribe((data)=>{
        item.Details.forEach((value, index) => {
          item.Details.splice(index,1);
        });
        this.Items2 = List(data);
        this.Items2.forEach(item2 =>{
          item.Details.push(item2);
        })
        
      })
  }


  SelectItem(item){
    this.ItemSelected.emit(item);
    this.Items.forEach(value => {
      value.Selected = false;
    })
    item.Selected = true;
  }

  private setActiveItem(value: number){
    if(value == 40 && this.Items != null && this.Items.size > 0){
      if(this.selectedItemIndex + 1 <= this.Items.size - 1){
        this.selectedItemIndex++;
        if(this.selectedItemIndex > this.Items.size - 1)
          this.selectedItemIndex = this.Items.size - 1;
          document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).parentElement.scrollTop = document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).offsetTop;
      }
    }
    else if(value == 38 && this.Items != null && this.Items.size > 0){
      this.selectedItemIndex--;
      if(this.selectedItemIndex < 0)
        this.selectedItemIndex = 0;
        document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).parentElement.scrollTop = document.getElementById(this.defaultTableName + '-' + this.selectedItemIndex).offsetTop;
    }

   
    if(this.Items != null && this.Items.size > 0){
      this.Items.filter(item => item.Selected == true).forEach(item => item.Selected = false);
      let tempItem = this.Items.get(this.selectedItemIndex);
      if(tempItem == null){
        //tempItem = this.Items.get(0);
        this.selectedItemIndex = 0;
        tempItem = this.Items.get(this.selectedItemIndex);
      }
      tempItem.Selected = true;
      this.changeDetectorRef.markForCheck();
    }
    
  }

  RefreshData(){
    this.RefreshDataClicked.emit();
  }  

  setColumnsRatio(ratio: number){
    this.ColumnsRatioChanged.emit('col-md-' + ratio);
  }

  currencyCheck(event, control: string): boolean
  {
    let pattern = /^\d+\.?\d{0,2}$/;
    let result = pattern.test(event.key);
    if (control == null)
      return result;
    else
      return pattern.test(control.toString() + event.key);
  }

 
}
